import type { TFunction } from 'i18next'

export type EnumField = 'activity' | 'routeStatus' | 'route_type' | 'difficulty'

export interface EnumDisplay {
  label: string
  tooltip?: string
  colour?: string
}

const ENUM_COLOURS: Record<EnumField, Record<string, string>> = {
  activity: {
    hiking: '#1a5a44',
    running: '#e66725',
    cycling: '#5b6abf',
  },
  routeStatus: {
    draft: '#8a6a18',
    published: '#1a5a44',
    archived: '#6b7280',
  },
  route_type: {
    loop: '#5b6abf',
    point_to_point: '#2a7a5a',
    out_and_back: '#7a5a2a',
  },
  difficulty: {
    easy: '#4cae50',
    moderate: '#e6a03b',
    hard: '#d97836',
    expert: '#c54a3a',
  },
}

export function enumDisplay(field: EnumField, value: string, t: TFunction): EnumDisplay {
  const labelKey = `enumLabel_${field}_${value}`
  const tooltipKey = `enumTooltip_${field}_${value}`
  const label = t(labelKey, { defaultValue: value })
  const tooltip = t(tooltipKey, { defaultValue: '' })
  return {
    label,
    tooltip: tooltip || undefined,
    colour: ENUM_COLOURS[field]?.[value],
  }
}
